import { Injectable } from '@angular/core';
import { UserService, PolicyService, Strike, StrikePolicies, UserStrikes } from '@bluecrew/crew-member-backend-angular-client';
import { SegmentCMOSService } from '../segment-cmos.service';
import { getLogName, LOG_NAME, LOG_TYPE } from 'src/app/util/logger/log-names';

@Injectable({
  providedIn: 'root',
})
export class PolicyClientService {
  
  constructor(
    private readonly userService: UserService,
    private readonly policyService: PolicyService,
    private readonly segmentCMOS: SegmentCMOSService
    ) {}

  async getAttendancePolicies(): Promise<StrikePolicies> {
    try {
      return await this.policyService.getAttendancePolicies().toPromise();
    } catch (error) {
      const errorLog = getLogName(LOG_NAME.getAttendancePolicies, LOG_TYPE.error);
      this.segmentCMOS.addEvent(errorLog);
      throw error;
    } 
  }

  getUnexpiredStrikes(): Promise<UserStrikes> {
    return this.userService.getUserUnexpiredStrikes(false).toPromise();
  }

  getUnacknowledgedStrikes(): Promise<UserStrikes> {
    return this.userService.getUserUnexpiredStrikes(true).toPromise();
  }

  acknowledgeStrikes(strikes: Strike[]) {
    this.userService.postAcknowledgeStrikes({strikes}).toPromise();
  }
}
